import { api_configuration } from "../../common";
import api_app = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.application.alan_api;

export default function supportsSelfReference(root: api_app.Centry_reference_definition): boolean {
	switch (root.properties.type.state.name) {
		case "simple":
			return false;
		case "sibling": {
			const $ = root.properties.type.state.node;
			switch ($.properties.definition.properties.graph_participation.state.name) {
				case "no": {
					const $$ = $.properties.definition.properties.graph_participation.state.node;
					switch ($$.properties.support_self_reference.state.name) {
						case "no":
							return false;
						case "yes":
							return true;
						default:
							unexpectedState($$.properties.support_self_reference.state);
					}
					break;
				}
				case "yes":
					return false;
				default:
					unexpectedState($.properties.definition.properties.graph_participation.state);
			}
			break;
		}
		default:
			unexpectedState(root.properties.type.state);
	}
}
